import { memo } from 'react'

import Help from './Help'
import { Container, Title, Version } from './Styles'
import Logo from 'assets/LogoFull'

const Header = ({ noHelp }) => {
  return (
    <>
    <Container>
      {/* <Title>
        medvice.io<Version>V.1.2</Version>
      </Title> */}
      <Logo />
      <Help visible={!noHelp} />
    </Container>
    </>
  )
}

Header.whyDidYouRender = true

export default memo(Header)
